var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20L1.3793 15C0.482773 13.4483 0 11.7241 0 9.93102C0 4.48277 4.48277 0 9.96551 0C15.4482 0 20 4.48277 20 9.93102C20 15.3793 15.4483 20 9.96551 20C8.24137 20 6.58621 19.4483 5.10344 18.6207L0 20Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37977 16.8276L5.69012 17C6.96598 17.7931 8.44875 18.2758 10.0005 18.2758C14.5177 18.2758 18.2763 14.5172 18.2763 9.93099C18.2763 5.34478 14.5177 1.72412 9.96598 1.72412C5.41426 1.72412 1.72461 5.37928 1.72461 9.93099C1.72461 11.5172 2.17289 13.0689 3.00047 14.3793L3.20738 14.6896L2.4143 17.5862L5.37977 16.8276Z",
    fill: "#55CD6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30997 5.31037L6.65481 5.27588C6.4479 5.27588 6.24102 5.34486 6.10309 5.48279C5.79274 5.75865 5.27551 6.27588 5.13758 6.96557C4.89622 8.00006 5.27551 9.24143 6.17208 10.4828C7.06864 11.7242 8.79278 13.7242 11.8272 14.5862C12.7927 14.8621 13.5514 14.6897 14.1721 14.3104C14.6549 14 14.9652 13.5173 15.0686 13L15.1721 12.5172C15.2066 12.3793 15.1376 12.2069 14.9997 12.1379L12.8272 11.138C12.6893 11.069 12.5169 11.1035 12.4134 11.2414L11.5514 12.3448C11.4824 12.4138 11.379 12.4483 11.2755 12.4138C10.6893 12.2069 8.72379 11.3793 7.65481 9.31037C7.62032 9.20693 7.62032 9.10346 7.6893 9.03451L8.51688 8.1035C8.58587 8.00006 8.62032 7.86213 8.58587 7.75865L7.58586 5.51729C7.55133 5.41381 7.4479 5.31037 7.30997 5.31037Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.4d64b693525e970f6a0da375b9852ab9.svg";
export { ForwardRef as ReactComponent };